import { AmountTextInput } from "@components/TextInput/AmountTextInput";
import React from "react";

import {
  CoerceToSafeIntStatus,
  SafeInt,
  coerceToSafeInt,
} from "@every.org/common/src/codecs/number";
import { Currency } from "@every.org/common/src/entity/types";
import {
  DECIMAL_OFFSET_FOR_CURRENCY,
  minimumDenominationAmountToCurrencyValue,
} from "@every.org/common/src/helpers/currency";

interface RaisedOfflineInputProps {
  raisedOffline: SafeInt | undefined | null;
  currency: Currency;
  setRaisedOffline: (amount: SafeInt | undefined | null) => void;
}

export function RaisedOfflineAmountInput({
  raisedOffline,
  setRaisedOffline,
  currency,
}: RaisedOfflineInputProps) {
  const inputValue = raisedOffline
    ? minimumDenominationAmountToCurrencyValue({
        currency,
        amountInMinDenom: raisedOffline,
      }).amount.toString()
    : "";

  const onRaisedOfflineChange = (amount: string) => {
    if (amount === "") {
      setRaisedOffline(null);
    }

    try {
      const newValue = coerceToSafeInt({
        num:
          Number.parseInt(amount) *
          Math.pow(10, DECIMAL_OFFSET_FOR_CURRENCY[currency]),
      });

      if (
        newValue.status === CoerceToSafeIntStatus.IS_SAFE_INT &&
        newValue.num >= 0
      ) {
        setRaisedOffline(newValue.num);
      }
    } catch (e) {
      return;
    }
  };

  return (
    <AmountTextInput
      data-tname="raisedOffline"
      id="raisedOfflineInput"
      name="raisedOfflineAmountInput"
      amount={inputValue || ""}
      setAmount={onRaisedOfflineChange}
      css={{ maxWidth: "unset" }}
      shorten
    />
  );
}
